export default __webpack_public_path__ + "2cb7fc39e8ca6d6fc24304a705c80f15.png";